import { contentElements as contentElementsBase, Teaser as TeaserBase } from './contentElements';

export const Teaser = TeaserBase;

export const contentElements = contentElementsBase;
